import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, LuxButton } from "../common/Primitives";
import { Reveal } from "../motion/Reveal";
import { IMG, SITE } from "../../config/site";
import { WhatsAppButton } from "../common/WhatsAppButton";
import { useUI } from "../../context/UIContext";

export const PartnerCTA = () => {
  const ref = useRef(null);
  const { openEnquiry } = useUI();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-3%", "3%"]);

  return (
    <section id="contact" ref={ref} data-testid="cta-section" className="relative overflow-hidden bg-[#21170F]">
      <div className="absolute inset-y-0 right-0 w-full overflow-hidden lg:w-[min(100%,calc(640px*1.49))]">
        <motion.img src={IMG.cta} alt="A TOYAM Alkaline Water bottle with a glass of clear water and fine tableware on dark espresso marble" loading="lazy" style={{ y }}
          className="absolute inset-x-0 -top-[3%] h-[106%] w-full object-cover object-[72%_center] opacity-60 sm:opacity-100" />
        <div className="absolute inset-y-0 left-0 hidden w-1/2 bg-gradient-to-r from-[#21170F] to-transparent lg:block" />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(90deg,#21170F_0%,rgba(33,23,15,.9)_35%,rgba(33,23,15,.3)_70%,transparent_100%)]" />
      <div className="relative mx-auto flex min-h-[560px] max-w-[1440px] items-center px-5 py-24 sm:px-8 lg:min-h-[640px] lg:px-12">
        <Reveal className="max-w-xl">
          <Eyebrow>Let's create something exceptional</Eyebrow>
          <h2 className="mt-6 text-5xl leading-[1] text-[#F8F3E9] sm:text-6xl lg:text-[4.6rem]">Partner with TOYAM</h2>
          <p className="mt-8 max-w-lg text-[15px] leading-[1.8] text-[#F8F3E9]/80">
            We work with hotels, restaurants, and resorts to explore a premium water experience that complements your brand, your values,
            and your commitment to exceptional hospitality.
          </p>
          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <LuxButton arrow onClick={() => openEnquiry("Hotel supply partnership")} data-testid="cta-enquire-btn">Enquire now</LuxButton>
            <LuxButton variant="line" onClick={() => openEnquiry("Sample request")} data-testid="cta-sample-btn">Request a sample</LuxButton>
          </div>
          {SITE.contact.phones?.length > 0 && (
            <p className="mt-8 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-[#E8D6B7]/85" data-testid="cta-phones">
              <span className="text-[10px] font-bold uppercase tracking-[0.26em] text-[#B18A4A]">Or call</span>
              {SITE.contact.phones.map((p) => (
                <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="link-lux hover:text-[#F8F3E9]">{p}</a>
              ))}
            </p>
          )}
          <WhatsAppButton className="mt-5" testid="cta-whatsapp-btn" />
        </Reveal>
      </div>
    </section>
  );
};
